import React from 'react';
import { get } from 'js/utils/fetch.util';
import { Loader } from 'js/components/common/Loader';
import { useDataFetch } from 'js/hooks/useDataFetch';
import { useUpdateEffect } from 'js/hooks/useUpdateEffect';
import { usePromiseResolvers } from 'js/hooks/usePromiseResolvers';

import * as hooks from './hooks';
import * as helpers from './helpers';
import { WebContentInner } from './components/WebContentInner';

export const WebContent = ({
    id,
    content = undefined,
    url = undefined,
    popupId = undefined,
    className = '',
    showLoader = true,
    addLoadingPromise = null
}) => {
    const webContentUrl = hooks.useWebContentUrl({ webContentId: id, url });

    const [{ isLoading, data: fetchedContent }, refetch] = useDataFetch({
        fetch: get,
        params: webContentUrl,
        initialData: content,
        initialIsLoading: Boolean(id),
        shouldFetch: helpers.shouldFetch
    });

    useUpdateEffect(() => {
        refetch(webContentUrl);
    }, [refetch, webContentUrl]);

    usePromiseResolvers({
        isApplicable: Boolean(id),
        isReadyToResolve: Boolean(id && !isLoading),
        addLoadingPromise
    });

    const currentContent = id ? fetchedContent : content;

    if (currentContent) {
        return (
            <WebContentInner
                id={id}
                popupId={popupId}
                className={className}
                content={currentContent}
                context={`webContent::${id}`}
            />
        );
    }

    if (isLoading && showLoader) {
        return <Loader />;
    }

    return null;
};
